<div style="padding: 1rem;">
    {{ 'msg.user.rawmaterial.popin.blocked-results.intro' | translate }}
    <ul>
        <li *ngFor="let blockedResult of allBlockedResults" class="nutrient-li">
            {{blockedResult.nutrientCode}}
            <ul>
                <li>
                    {{ 'msg.user.rawmaterial.calculated-result' | translate }} : {{ getCalculatedValue(blockedResult) }}
                </li>
                <li>
                    {{ 'label.common.ceiling-value' | translate }} : {{ getCeilValue(blockedResult) }}
                </li>
                <li>
                    {{ 'label.common.floor-value' | translate }} : {{ getFloorValue(blockedResult) }}
                </li>
            </ul>
        </li>
    </ul>
    <div class="asi-container" fxLayoutAlign="center center">
      <button
        pButton
        class="neq-primeng-button-text"
        (click)="closeDialog()"
        label="{{'msg.common.validation.ok' | translate}}"></button>
    </div>
</div>
